import React from 'react';

const MARK_STYLE: React.CSSProperties = {
  background: 'color-mix(in srgb, var(--gt-primary) 18%, transparent)',
  borderRadius: 'var(--radius-xs)',
  padding: '0 1px',
  color: 'inherit',
  fontWeight: 'inherit',
};

export function highlight(text: string | null | undefined, keywords: string[]): React.ReactNode {
  const kws = keywords.filter(Boolean);
  if (!text || kws.length === 0) return text ?? '';

  const escaped = kws.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const regex = new RegExp(`(${escaped.join('|')})`, 'gi');
  const parts = text.split(regex);

  if (parts.length === 1) return text;

  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1
          ? <mark key={i} style={MARK_STYLE}>{part}</mark>
          : part
      )}
    </>
  );
}
